"use client";

import { Mail } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ContactForm() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.1,
    once: true
  });
  return <section ref={sectionRef} className={`py-20 px-4 md:px-8 bg-background transition-all duration-200 ease-[cubic-bezier(0.4,0,0.2,1)] ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-start">
          {}
          <div className="space-y-6">
            <h2 className="text-4xl md:text-5xl font-display font-bold text-black leading-tight">
              Connect
            </h2>
            <p className="text-muted text-lg leading-relaxed">
              With over 20 years in media and publishing, I provide technical marketing solutions
              that keep operations running smoothly and data reliable. I work with teams to
              streamline processes, solve challenges efficiently, and maintain systems that perform
              consistently.
            </p>
            <div className="flex items-center gap-3 text-muted">
              <Mail className="size-5 text-primary" />
              <span className="text-sm font-medium">hello@bozang.digital</span>
            </div>
          </div>

          {}
          <div className="hidden md:block absolute left-1/2 top-20 bottom-20 -translate-x-1/2">
            <Separator orientation="vertical" className="h-full bg-gradient-to-b from-primary/20 via-secondary/30 to-accent/20" />
          </div>

          {}
          <div className="relative">
            <div className="bg-white p-10 rounded-2xl border border-gray-100 shadow-xl backdrop-blur-md">
              <div className="space-y-6" dangerouslySetInnerHTML={{
              __html: `[contact-form-7 id="c75c83b" title="Contact form 1"]`
            }} />
            </div>
          </div>
        </div>
      </div>

      {}
      <style jsx>{`
        .wpcf7-form .wpcf7-form-control {
          @apply bg-white border-gray-200 rounded-lg px-5 py-4 w-full transition-all duration-200 focus:border-[#2EAF7D] focus:ring-4 focus:ring-[#2EAF7D]/10 outline-none;
          font-size: 1.0625rem;
          color: #1A1A1A;
        }
        .wpcf7-form textarea.wpcf7-form-control {
          min-height: 150px;
          resize: vertical;
        }
        .wpcf7-form input[type='submit'] {
          @apply w-full bg-[#2EAF7D] text-white font-semibold rounded-lg py-4 shadow-lg transition-all duration-200 ease-out hover:bg-[#37C58F] hover:-translate-y-0.5 active:bg-[#27966A] active:scale-[0.98] cursor-pointer;
        }
        .wpcf7-mail-sent-ok {
          @apply bg-green-50 border border-green-200 text-green-800 p-5 rounded-xl mb-6 font-medium;
        }
        .wpcf7-validation-errors,
        .wpcf7-mail-failed {
          @apply bg-red-50 border border-red-200 text-red-800 p-5 rounded-xl mb-6 font-medium;
        }
      `}</style>
    </section>;
}